import { RestProvider } from 'dataSources/types/restProvider';
import { BaseResource } from 'e100-data-providers';

import {
  FavouriteBrand,
  CountriesBrandsFilter,
  CountryBrands
} from '../types';

export class BrandsApi extends BaseResource {
  path: string = '';

  constructor(provider: RestProvider) {
    super(provider);
    this.path = '';
  }

  async getFavouriteBrands(): Promise<{ favouriteBrands: FavouriteBrand[] }> {
    return this.getChildResource('favourite/brands').getItems();
  }

  async addFavouriteBrands(billingIds: FavouriteBrand['billingId'][]): Promise<{
    favouriteBrands: Pick<FavouriteBrand, 'billingId' | 'logo' | 'title'>[]
  }> {
    return this.send(this.getChildResource('favourite/brands').request.put().setBody(billingIds));
  }

  async deleteFavouriteBrands(billingIds: FavouriteBrand['billingId'][]) {
    return this.send(this.getChildResource('favourite/brands').request.del().setBody(billingIds));
  }

  async getCountriesBrands(filter: CountriesBrandsFilter): Promise<{ countries: CountryBrands[]; }> {
    return this.send(
      this.getChildResource("countries/brands")
        .request.post()
        .setBody(filter)
    );
  }
}
